export const IDENTICAL_PALLETS = "identicalPallets";
